import { CompassOutlined } from '@ant-design/icons';
import { CSSProperties } from 'react';
import { useDraggableFloat } from './useDraggableFloat';

const STORAGE_KEY = 'tf_tour_button_pos';
const SIZE = { width: 34, height: 34 };

type PropsType = {
    tooltip: string;
    onClick: () => void;
};

// A small circular button the user can drag anywhere on screen; its position
// is remembered (one shared spot across every page, via localStorage) so it
// doesn't jump back on the next page or reload.
const DraggableTourButton = ({ tooltip, onClick }: PropsType) => {
    const { pos, cursor, handlers, wasDragged } = useDraggableFloat(STORAGE_KEY, SIZE, () => ({
        // Matches the old fixed FloatButton spot (insetInlineEnd 155, insetBlockEnd 112)
        // so a user who never drags it sees no change.
        x: window.innerWidth - 155 - SIZE.width,
        y: window.innerHeight - 112 - SIZE.height,
    }));

    const style: CSSProperties = {
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        width: SIZE.width,
        height: SIZE.height,
        borderRadius: '50%',
        border: 'none',
        background: '#1b73e8',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        cursor,
        zIndex: 1100,
        touchAction: 'none',
        userSelect: 'none',
        padding: 0,
    };

    return (
        <button
            type="button"
            title={tooltip}
            aria-label={tooltip}
            style={style}
            {...handlers}
            onClick={() => {
                if (!wasDragged()) onClick();
            }}
        >
            <CompassOutlined />
        </button>
    );
};

export default DraggableTourButton;
